import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { fetchListOrganizationOptions } from '../actions';

const OrganizationSelect = ({ filterOptions, setFilterOptions }) => {
     const dispatch = useDispatch();

     const [organizationOptions, setOrganizationOptions] = useState([]);

     const [isLoading, setIsLoading] = useState('');

     const fetchOrganizationOptions = () => {
          dispatch(fetchListOrganizationOptions(filterOptions, setOrganizationOptions, setIsLoading));
     };

     const onChangeSelect = (e) => {
          const value = e ? e.value : '';

          const newFilter = { ...filterOptions };
          if (value) {
               newFilter.organizationId = value;
          } else {
               delete newFilter.organizationId;
          }

          setFilterOptions(newFilter);
     };

     const onMenuOpen = () => {
          fetchOrganizationOptions();
     };

     return (
          <Select
               id="user"
               classNamePrefix="react-select"
               placeholder="Select Organization ..."
               className="flex-1"
               options={organizationOptions}
               isLoading={isLoading}
               onChange={onChangeSelect}
               onMenuOpen={onMenuOpen}
               isClearable
          />
     );
};

OrganizationSelect.propTypes = {
     filterOptions: PropTypes.object,
     setFilterOptions: PropTypes.func,
};

export default memo(OrganizationSelect);
